import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { betaKeys } from "@/lib/query-keys";
import type { UserExtraInformation } from "@/types/domain";

/**
 * Marca el modal de introducción como visto. Se llama al cerrarlo, lo haya
 * completado o no; reabrirlo desde el menú ya no pasa por aquí.
 */
export function useMarkIntroSeen() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetchToBackend<UserExtraInformation>(
        "/userextrainformation/intro-seen",
        { method: "POST" },
      ),
    onSuccess: (updated) => {
      // Se escribe la caché en el acto para que el modal no reaparezca en el
      // parpadeo entre la respuesta y el refetch.
      qc.setQueryData<UserExtraInformation>(betaKeys.info, (prev) =>
        prev ? { ...prev, ...updated } : prev,
      );
      qc.invalidateQueries({ queryKey: betaKeys.info });
    },
  });
}
